import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Avatar,
  Paper,
  Grid,
  Card,
  Menu,
  MenuItem,
  CircularProgress,
  IconButton,
  Switch,
} from "@mui/material";
import {
  getDatabase,
  ref,
  onValue,
  set,
  get,
  update,
  child,
  onChildAdded,
  onChildChanged,
  remove,
  onChildRemoved,
} from "firebase/database";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { ToastContainer, toast } from "react-toastify";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TokenDialogBox from "../../DialogBox/tokenData";
import EmptyData from "components/EmptyData";
import SubscriptionData from "../../DialogBox/subscriptionData";
import { useSelector } from "react-redux";

const AllPayments = () => {
  const [allData, setAllData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedNotification, setselectedNotification] = useState({});
  const [checkSuperAdmin, setCheckSuperAdmin] = useState(null);
  const [adminState, setAdminState] = useState(null);
  const getUserState = useSelector((state) => state?.data?.getUserState);

  const navigate = useNavigate();

  const openModal = () => {
    setOpen(true);
  };
  const close = () => {
    setOpen(false);
  };

  const getData = () => {
    const curruntAdminData = JSON.parse(localStorage.getItem("user"));
    const getAdminState = curruntAdminData?.state;
    const useradmin = curruntAdminData?.superAdmin;
    setCheckSuperAdmin(useradmin);
    setAdminState(getAdminState);

    const db = getDatabase();
    const dbRef = ref(db, "payment");

    get(dbRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          // console.log("paymentlog", data);

          const usersRef = ref(db, "users");
          get(usersRef).then((userSnapshot) => {
            const usersData = userSnapshot.exists() ? userSnapshot.val() : {};

            const mergedData = Object.entries(data)
              .map(([key, value]) => {
                //   console.log("values", value);
                const userId = value?.userId;
                const userData = usersData[userId] || null;

                // return {
                //   id: key,
                //   ...value,
                //   user: userData,
                // };

                // if (useradmin || (getAdminState && userData?.state === getAdminState)) {
                //   return {
                //     id: key,
                //     ...value,
                //     user: userData,
                //   };
                // }

                if (useradmin) {
                  if (
                    (useradmin && getUserState === "") ||
                    (useradmin && getUserState === "All State")
                  ) {
                    return {
                      id: key,
                      ...value,
                      user: userData,
                    };
                  } else {
                    if (userData?.state === getUserState) {
                      return {
                        id: key,
                        ...value,
                        user: userData,
                      };
                    }
                  }
                } else {
                  if (getAdminState && userData?.state === getAdminState) {
                    return {
                      id: key,
                      ...value,
                      user: userData,
                    };
                  }
                }
                return null;
              })
              .filter(Boolean);

            setAllData(mergedData);
            // console.log("finalData", mergedData);
          });
        } else {
          setAllData([]);
        }
      })
      .catch((error) => {
        // console.error("Error fetching data:", error);
        setAllData([]);
      });
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/authentication/sign-in");
    }
    getData();
  }, [getUserState]);

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };
  return (
    <DashboardLayout>
      <MDBox pt={12} pb={3}>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{
                  textAlign: "center",
                }}
              >
                <ToastContainer />
                <MDTypography
                  variant="h6"
                  color="white"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                  }}
                >
                  {checkSuperAdmin
                    ? getUserState === ""
                      ? "ALL STATE "
                      : `${getUserState?.toUpperCase()} STATE `
                    : `${adminState?.toUpperCase()} STATE `}
                  PAYMENTS DETAILS DASHBOARD
                </MDTypography>
              </MDBox>

              {allData ? (
                <MDBox>
                  <TableContainer component={Paper}>
                    <Table aria-label="user table">
                      <TableBody>
                        <TableRow>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                          >
                            SR
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                          >
                            Name
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                            align="center"
                          >
                            Email
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                            align="center"
                          >
                            Phone
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                            align="center"
                          >
                            Gender
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                            align="center"
                          >
                            State
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                            align="center"
                          >
                            Payment Mode
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                            align="center"
                          >
                            Amount
                          </TableCell>
                          <TableCell
                            style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                            align="center"
                          >
                            Current Date
                          </TableCell>
                        </TableRow>
                      </TableBody>
                      {allData
                        .sort((a, b) => b.currentTimeStamp - a.currentTimeStamp)
                        .map((notification, index) => (
                          <TableRow key={index} sx={{ height: "auto" }}>
                            <TableCell align="center" className="rounded" sx={{ padding: "6px" }}>
                              {index + 1}
                            </TableCell>
                            <TableCell
                              sx={{ padding: "6px", fontSize: "14px" }}
                              component="th"
                              scope="row"
                            >
                              <Avatar
                                src={notification?.user?.userImage}
                                alt={notification?.user?.userName}
                              />
                              {notification?.user?.userName}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="rounded"
                              sx={{ padding: "6px", fontSize: "14px" }}
                            >
                              {notification?.user?.userEmail}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="rounded"
                              sx={{ padding: "6px", fontSize: "14px" }}
                            >
                              {notification?.user?.userPhone}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="rounded"
                              sx={{ padding: "6px", fontSize: "14px" }}
                            >
                              {notification?.user?.userGender}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="rounded"
                              sx={{ padding: "6px", fontSize: "14px" }}
                            >
                              {notification?.user?.state}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="rounded"
                              sx={{ padding: "6px", fontSize: "14px" }}
                            >
                              {notification?.type}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="rounded"
                              sx={{ padding: "6px", fontSize: "14px" }}
                            >
                              {`₦ ${notification?.amount}`}
                            </TableCell>
                            <TableCell align="center" className="rounded" sx={{ padding: "6px" }}>
                              {formatDate(notification?.currentTimeStamp)}
                            </TableCell>
                          </TableRow>
                        ))}
                    </Table>
                  </TableContainer>
                </MDBox>
              ) : (
                <EmptyData />
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default AllPayments;
